import { NavLink } from 'react-router-dom';

import { NAV_ITEMS } from './nav';
import styles from './MobileNav.module.css';

export function MobileNav() {
  return (
    <nav className={styles.nav} aria-label="Навигация по инструментам">
      {NAV_ITEMS.map((item) => {
        const Icon = item.icon;
        return (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              isActive ? `${styles.item} ${styles.active}` : styles.item
            }
          >
            <Icon size={20} strokeWidth={1.5} />
            <span className={styles.label}>{item.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
